import { RadioGroup } from '@gemini/ui';
import { IFieldProps, IFieldValues } from '@mfe-types/field';

const RadioWrapper = ({ field, options, texts, styles }: IFieldProps<any, any>) => {
    let items: Array<any> = [];
    if (options?.values) {
        items = options.values.map((option: IFieldValues) => ({
            label: option.label,
            value: option.value,
        }));
    }

    return (
        <RadioGroup
            label={
                texts.label
                    ? texts.label
                    : {
                          content: texts?.ariaLabel?.text ?? '',
                          tooltip: '',
                          isHidden: undefined,
                      }
            }
            {...styles}
            {...field}
            items={items}
            direction={field.direction ?? 'horizontal'}
            helper={texts.additionalText}
        />
    );
};

export default RadioWrapper;
